/**
 * Coverage panels for CounsellorReport "My work".
 * Lifetime = period-invariant. Period = follows selected Toolbar period (incl. All time).
 * 100% = counsellor caseload.
 */

const METRIC_DEFS = [
	{ key: 'withApplication', label: '≥1 Application', tone: 'orange', icon: 'school' },
	{ key: 'withAssignment', label: '≥1 Assignment', tone: 'purple', icon: 'assignment' },
	{ key: 'withSession', label: '≥1 Session', tone: 'green', icon: 'event_available' },
]

const pctFor = (block, key) => {
	const pctKey = `${key}Pct`
	if (block && typeof block[pctKey] === 'number') return block[pctKey]
	return 0
}

export const buildCoveragePanels = ({ lifetime, period } = {}) => [
	{
		title: 'Lifetime Coverage',
		label: 'All-time engagement across caseload.',
		metrics: METRIC_DEFS.map(m => ({
			label: m.label,
			val: pctFor(lifetime, m.key),
			tone: m.tone,
			icon: m.icon,
		})),
	},
	{
		title: 'Period Coverage',
		label: 'Engagement in the selected period across caseload.',
		metrics: METRIC_DEFS.map(m => ({
			label: m.label,
			val: pctFor(period, m.key),
			tone: m.tone,
			icon: m.icon,
		})),
	},
]
